// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3cQT5","insightsList":"newBusinessInsightsMenu_insightsList__EeGK4","active":"newBusinessInsightsMenu_active__1IQNv"};